import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TrackReportView as TrackReportViewMutation,
    TrackReportViewVariables,
    TrackReportViewInput,
} from 'nutshell-graphql-types';

import GET_RECENTLY_VIEWED_REPORTS from '../../overview/graphql/queries/get-recently-viewed-reports.graphql';

import TRACK_REPORT_VIEW from '../mutations/track-report-view.graphql';

export const useTrackReportView = (): {
    trackReportView: (arg1: TrackReportViewInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [trackReportView, {loading, error}] = useMutation<
        TrackReportViewMutation,
        TrackReportViewVariables
    >(TRACK_REPORT_VIEW, {
        update: (cache, {data}) => {
            if (data && data.trackReportView && data.trackReportView.recentlyViewedReports) {
                cache.writeQuery({
                    query: GET_RECENTLY_VIEWED_REPORTS,
                    data: {
                        recentlyViewedReports: data.trackReportView.recentlyViewedReports,
                    },
                });
            }
        },
    });

    return {
        trackReportView: (input: TrackReportViewInput) => trackReportView({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
